import { alert as dhxAlert, confirm as dhxConfirm, message as dhxMessage } from "dhx-suite";
import "./Message.scss";
export const showAlert = (mensaje, callback) =>{
  dhxAlert({
    header: "MarketPlace GP",
    text: mensaje,
    buttonsAlignment: "center",
    buttons: ["ok"],
  }).then(callback);
};

export const showConfirm = (mensaje,LabelOKButton,callback = ()=>{}) =>{
  dhxConfirm({
    header: "MarketPlace GP",
    text: mensaje,
    buttonsAlignment: "center",
    buttons: ["cancel", LabelOKButton]
  }).then((answer)=>{ 
    if (answer){        
      callback();
    }    
    else {        
      console.log("cancelled")    
    }
  });
};

export const showMessage = (mensaje,type = 'default') =>{
  type = 'sa-'+type;
  dhxMessage({
    text: mensaje,
    icon: "dxi-close",
    css: type,     
    expire: 3000
  });
};
